import { PaginationContextProvider } from 'utils/contexts/pagination';
import { SortingContextProvider } from 'utils/contexts/sorting';

import { SORT_BY_FIELD } from '../constants';
import { Modals } from '../modals';
import { CampaignFoldersPage } from './CampaignFoldersPage';
import { CampaignFiltersContextProvider } from './contexts/CampaignFiltersContextProvider';
import { CampaignIndexModalProvider } from './contexts/CampaignIndexModalContext';
import { CampaignQueryContextProvider } from './contexts/CampaignQueryContextProvider';
import { CreateCampaignContextProvider } from './contexts/CreateCampaignProvider';
import { SelectionContextProvider } from './contexts/SelectionContext';

export const CampaignFoldersContext = () => (
  <PaginationContextProvider>
    <SortingContextProvider defaultSortField={SORT_BY_FIELD.UPDATED_AT}>
      <CampaignFiltersContextProvider>
        <CampaignQueryContextProvider>
          <SelectionContextProvider>
            <CreateCampaignContextProvider>
              <CampaignIndexModalProvider>
                <CampaignFoldersPage />
                <Modals />
              </CampaignIndexModalProvider>
            </CreateCampaignContextProvider>
          </SelectionContextProvider>
        </CampaignQueryContextProvider>
      </CampaignFiltersContextProvider>
    </SortingContextProvider>
  </PaginationContextProvider>
);
